var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _ellipse, _path10, _path11, _path12, _path13, _path14, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.43,113.62v318.73H71.62V121.25c0-28.72,17.08-45.81,38.17-45.81h595.47c21.09,0,38.17,17.08,38.17,38.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.43,432.35v473.32c0,21.09-17.08,38.17-38.17,38.17H109.79c-21.09,0-38.17-17.08-38.17-30.54v-480.96h671.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.04,329.28v-150.78c0-14.76,11.96-26.72,26.72-26.72h465.69c14.76,0,26.72,11.96,26.72,26.72v150.78c0,14.76-11.96,26.72-26.72,26.72H193.76c-14.76,0-26.72-11.96-26.72-26.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.94,356h-38.17c-14.75,0-26.72-11.97-26.72-26.72v-150.78c0-14.75,11.97-26.72,26.72-26.72h38.17c-14.75,0-26.72,11.97-26.72,26.72v150.78c0,14.75,11.97,26.72,26.72,26.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M684.26,535.41v152.68h-258.61v-179.4h231.89c14.75,0,26.72,11.97,26.72,26.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.65,508.69v179.4H167.04v-148.87c0-18.57,11.97-30.54,26.72-30.54h231.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.65,688.09v179.4h-231.89c-14.75,0-26.72-11.97-26.72-22.9v-156.5h258.61Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M684.26,688.09v152.68c0,14.75-11.97,26.72-26.72,26.72h-231.89v-179.4h258.61Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M657.54,494.38H193.76c-23.39,0-41.03,19.28-41.03,44.85v305.37c0,19.83,19.18,37.22,41.03,37.22h463.78c22.63,0,41.03-18.41,41.03-41.03v-305.37c0-22.63-18.41-41.03-41.03-41.03ZM669.95,535.41v138.37h-229.98v-150.78h217.58c6.84,0,12.41,5.57,12.41,12.41ZM181.36,539.23c0-9.7,4.99-16.22,12.41-16.22h217.58v150.78h-229.98v-134.55ZM181.36,844.6v-142.19h229.98v150.78h-217.58c-7.17,0-12.41-6.03-12.41-8.59ZM669.95,840.78c0,6.84-5.57,12.41-12.41,12.41h-217.58v-150.78h229.98v138.37Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.9,792.11h-103.06c-7.91,0-14.31-6.41-14.31-14.31s6.41-14.31,14.31-14.31h103.06c7.91,0,14.31,6.41,14.31,14.31s-6.41,14.31-14.31,14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.36,584.08h-27.67v-27.67c0-7.91-6.41-14.31-14.31-14.31s-14.31,6.41-14.31,14.31v27.67h-27.67c-7.91,0-14.31,6.41-14.31,14.31s6.41,14.31,14.31,14.31h27.67v27.67c0,7.91,6.41,14.31,14.31,14.31s14.31-6.41,14.31-14.31v-27.67h27.67c7.91,0,14.31-6.41,14.31-14.31s-6.41-14.31-14.31-14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566.14,598.39l19.57-19.57c5.59-5.59,5.59-14.65,0-20.24-5.59-5.59-14.65-5.59-20.24,0l-19.57,19.57-19.57-19.57c-5.59-5.59-14.65-5.59-20.24,0-5.59,5.59-5.59,14.65,0,20.24l19.57,19.57-19.57,19.57c-5.59,5.59-5.59,14.65,0,20.24,2.8,2.79,6.46,4.19,10.12,4.19s7.33-1.4,10.12-4.19l19.57-19.57,19.57,19.57c2.8,2.79,6.46,4.19,10.12,4.19s7.33-1.4,10.12-4.19c5.59-5.59,5.59-14.65,0-20.24l-19.57-19.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611.74,314.97h-26.72c-18.42,0-33.4-14.98-33.4-33.4v-55.35c0-18.42,14.98-33.4,33.4-33.4h26.72c18.42,0,33.4,14.98,33.4,33.4v55.35c0,18.42-14.98,33.4-33.4,33.4ZM585.02,221.45c-2.63,0-4.77,2.14-4.77,4.77v55.35c0,2.63,2.14,4.77,4.77,4.77h26.72c2.63,0,4.77-2.14,4.77-4.77v-55.35c0-2.63-2.14-4.77-4.77-4.77h-26.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.43,432.35v-42.94H138.42c-10.54,0-19.09-8.54-19.09-19.09V121.25c0-28.72,17.08-45.81,38.17-45.81h-47.71c-21.09,0-38.17,17.08-38.17,45.81v792.05c0,13.46,17.08,30.54,38.17,30.54h47.71c-21.09,0-38.17-17.08-38.17-30.54v-461.87c0-10.54,8.54-19.09,19.09-19.09h605.01Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 823.59,
    cy: 619.39,
    rx: 196.58,
    ry: 43.9
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1020.17,889.92v90.18c0,28.63-88,43.9-196.58,43.9s-196.58-15.27-196.58-43.9v-90.18c0,28.63,88,43.9,196.58,43.9s196.58-15.27,196.58-43.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1020.17,799.74v90.18c0,28.63-88,43.9-196.58,43.9s-196.58-15.27-196.58-43.9v-90.18c0,28.63,88,43.9,196.58,43.9s196.58-15.27,196.58-43.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1020.17,709.57v90.18c0,28.63-88,43.9-196.58,43.9s-196.58-15.27-196.58-43.9v-90.18c0,28.63,88,43.9,196.58,43.9s196.58-15.27,196.58-43.9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1020.17,619.39v90.18c0,28.63-88,43.9-196.58,43.9s-196.58-15.27-196.58-43.9v-90.18c0,28.63,88,43.9,196.58,43.9s196.58-15.27,196.58-43.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.73,824.83c-3.66,0-7.33-1.4-10.12-4.19-5.59-5.59-5.59-14.65,0-20.24l64.89-64.89c5.59-5.59,14.65-5.59,20.24,0,5.59,5.59,5.59,14.65,0,20.24l-64.89,64.89c-2.79,2.79-6.46,4.19-10.12,4.19h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 518.22,
    cy: 741.53,
    r: 14.31
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 575.48,
    cy: 814.06,
    r: 14.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeven);
export default __webpack_public_path__ + "static/media/seven.f92d5c826a864ba6b48f50153683e5c3.svg";
export { ForwardRef as ReactComponent };